import { Field } from "../FormLayout";
import { formatSchoolDate } from "../students/studentDisplay";
import { matchingDay, matchingPeriod, type QuickDay, type QuickPeriod } from "./reportPeriods";

/** The labelled dates above a report: From/To with quick periods, or one "as at" day with quick days. */

const day = (value: string | null | undefined) => formatSchoolDate(value) || "—";
const range = (start: string, end: string) => `${day(start)} – ${day(end)}`;

export function PeriodBar({ start, end, onChange, periods, hint }: { start: string; end: string; onChange: (start: string, end: string) => void; periods: QuickPeriod[]; hint: string }) {
  const active = matchingPeriod(periods, start, end);
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-end gap-3">
        <Field label="Period from" className="w-full sm:w-44">
          <input type="date" className="input mt-1" value={start} max={end || undefined} onChange={(event) => event.target.value && onChange(event.target.value, end)} />
        </Field>
        <Field label="Period to" className="w-full sm:w-44">
          <input type="date" className="input mt-1" value={end} min={start || undefined} onChange={(event) => event.target.value && onChange(start, event.target.value)} />
        </Field>
        <div role="group" aria-label="Quick periods" className="segmented mb-0.5">
          {periods.map((period) => (
            <button key={period.key} type="button" className="segmented-option" aria-pressed={active === period.key} onClick={() => onChange(period.start, period.end)} title={range(period.start, period.end)}>
              {period.label}
            </button>
          ))}
        </div>
      </div>
      <p className="text-xs text-gray-500">{hint}</p>
    </div>
  );
}

export function AsAtBar({ value, onChange, days, hint }: { value: string; onChange: (day: string) => void; days: QuickDay[]; hint: string }) {
  const active = matchingDay(days, value);
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-end gap-3">
        <Field label="Balances as at" className="w-full sm:w-44">
          <input type="date" className="input mt-1" value={value} onChange={(event) => event.target.value && onChange(event.target.value)} />
        </Field>
        <div role="group" aria-label="Quick dates" className="segmented mb-0.5">
          {days.map((entry) => (
            <button key={entry.key} type="button" className="segmented-option" aria-pressed={active === entry.key} onClick={() => onChange(entry.day)} title={day(entry.day)}>
              {entry.label}
            </button>
          ))}
        </div>
      </div>
      <p className="text-xs text-gray-500">{hint}</p>
    </div>
  );
}
